import api from "@/shared/api/api";

export interface CategoryItem {
  id: string;
  name: string;
  type?: string;
  order?: number | null;
  createdAt?: string;
  updatedAt?: string;
}

interface CategoriesResponse {
  data: CategoryItem[];
  meta: {
    totalPages: number;
    total: number;
    page: number;
    limit: number;
  };
}

export interface ListCategoriesParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const TEMPLATE_CATEGORY_TYPE = "TEMPLATE";

export const categoriesApi = {
  list: async (
    params?: ListCategoriesParams,
    signal?: AbortSignal,
  ): Promise<CategoryItem[]> => {
    const response = await api<CategoriesResponse>({
      url: "/v1/categories",
      method: "GET",
      params: {
        page: params?.page ?? 1,
        limit: params?.limit ?? 100,
        type: TEMPLATE_CATEGORY_TYPE,
        ...(params?.search ? { search: params.search } : {}),
      },
      signal,
    });
    return response.data;
  },
};
